import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=4b033d21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b033d21"]])

export default __exports__